export default {
    TABLE_DATA_FETCH_SUCCESS: "TABLE_DATA_FETCH_SUCCESS",
    TABLE_DATA_FETCH_FAILURE: "TABLE_DATA_FETCH_FAILURE",
    LOADING: "TABLE_DATA_LOADING"
}